import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Select from "react-select";
import { findObjInArr } from "@app/utils/CommonFunctions";
import * as mainService from '@app/services/mainService';

const ThoiListComponent = ({
                               onChange,
                               thoi_fk,
                               tableName,
                               id_tableName,
                               path_access,
                               required = false
                           }) => {
    const [listThois, setListThoi] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Memoize the selected value to prevent unnecessary re-renders
    const selectedValue = useMemo(() =>
            findObjInArr(listThois, thoi_fk),
        [listThois, thoi_fk]
    );

    // Memoize the request parameters
    const requestParams = useMemo(() => ({
        path_access,
        tableName,
        id_tableName
    }), [path_access, tableName, id_tableName]);

    const fetchThoiData = useCallback(async () => {
      //  if (!path_access || !tableName || !id_tableName) return;

        try {
            setLoading(true);
            setError(null);
            const response = await mainService.getAllThoi(requestParams);
            setListThoi(response || []);
        } catch (err) {
            console.error('Error fetching Thoi data:', err);
            setError('Failed to load data');
            setListThoi([]);
        } finally {
            setLoading(false);
        }
    }, [requestParams]);

    useEffect(() => {
        fetchThoiData();
    }, [fetchThoiData]);

    return (
        <>
            <label className={required ? "required" : ""}>
                Thời
            </label>
            <Select
                isClearable
                name="thoi_fk"
                onChange={onChange}
                value={selectedValue}
                options={listThois}
                isLoading={loading}
                placeholder={loading ? "Loading..." : "Select Thoi"}
                noOptionsMessage={() => error || "No options available"}
                isDisabled={loading || !!error}
            />
            {error && (
                <div className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                    {error}
                </div>
            )}
        </>
    );
};

export default ThoiListComponent;